<template>
  <div class="material-select" @click.stop>
    <label for="" @click.stop="expanded = !expanded" :style="styleLabel">
      {{ selected ? optionText(selected) : label }}
    </label>
    <span class="caret"></span>
    <transition name="fadeDown">
      <div class="dropdown" v-if="expanded">
        <form action="" class="search-form">
          <input v-model="search" type="text" placeholder="Filtrer..." autofocus>
        </form>
        <ul name="" id="" v-if="filteredOptions.length">
          <li v-for="option in filteredOptions" :key="option.value"
            :value="option.value"
            @click="onSelect(option)">
            {{ option.text }}
          </li>
        </ul>
        <ul v-else>
          <li style="text-align: center;">Aucune option...</li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Object],
    label: {
      type: String,
      required: true
    },
    styleLabel: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      selected: null,
      expanded: false,
      search: ''
    }
  },

  computed: {
    formattedOptions () {
      return this.options.map((option, index) => {
        if (option instanceof Object) {
          return option
        }

        return {
          value: option,
          text: option,
          shortText: option
        }
      })
    },

    filteredOptions () {
      return this.formattedOptions.filter(option => option.text.toLowerCase().match(new RegExp(this.search.toLowerCase()), 'g'))
    }
  },

  mounted () {
    window.document.addEventListener('click', () => {
      this.expanded = false
    })
  },

  methods: {
    onSelect (option) {
      this.selected = option
      this.expanded = false
      this.$emit('input', option)
      this.$emit('change', option)
      this.$emit('select', option)
    },

    optionText (option) {
      return option.shortText || option.text
    }
  }
}
</script>

<style lang="scss">
  .material-select {
    border-bottom: 2px solid #fff;
    position: relative;
    margin-bottom: 30px;
    width: 100%;
    transition: none;

    label {
      color: #4d4d4d;
      font-size: 20px;
      width: 100%;
      display: block;
      padding-bottom: 5px;
      cursor: pointer;
    }

    .caret {
      position: absolute;
      right: 20px;
      bottom: 15px;

      &:before {
        content: '';
        position: absolute;
        top: 25%;
        left: 6px;
        border-top: 6px solid #fff;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      }

      &:after {
        content: '';
        position: absolute;
        top: 25%;
        left: 6px;
        border-top: 5px solid #fff;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
      }
    }

    .dropdown {
      padding: 0;
      position: absolute;
      min-width: 200px;
      border: 1px solid #e4ebf3;
      border-radius: 0.5rem;
      background: #fff;
      z-index: 10;
      transition: none;

      .search-form {
        padding: 5px;
        background: hsla(0,0%,100%,.1);

        input {
          display: block;
          width: calc(100% - 10px);
          padding: 5px;
          background: transparent;
          color: #4d4d4d;
          border-radius: 3px;
          border: 0;

          &:focus, &:active {
            outline: 0;
          }
        }
      }

      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        border-top: 1px solid #e4ebf3;
        max-height: 180px;
        overflow: auto;

        li {
          padding: 10px;
          color: #4d4d4d;
          font-weight: 500;
          cursor: pointer;

          &:not(:last-child) {
            border-bottom: 1px solid #e4ebf3;
          }

          &:hover {
            background: #e4ebf3;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MaterialSelect.vue